import React from "react";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import {
  CollapsibleApplicantProfile,
} from "../../../../../shared/collapsible-applicant-profile/collapsible-applicant-profile";
import {
  ApplicantUserCitizenship,
  ApplicantUserContactInformation,
  ApplicantUserIdentityDetails,
  ApplicantUserProfessional,
  CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Document,
  Entity,
} from "../../../../../../generated";
import { useQuery } from "@apollo/client";
import { lookupCountryQuery } from './send-report-v1-country-query'
import { Country } from "../../../../../../types/country";

interface CollapsibleApplicantProfileContainerProps {
  caseId: string;
}

export const CollapsibleApplicantProfileContainer: React.FC<
  CollapsibleApplicantProfileContainerProps
> = (props) => {
  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Document,
    {
      variables: {
        sendReportCaseV1Id: props.caseId,
      },
    }
  );
  

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading || countryLoading}
      hasData={applicantDetailData?.sendReportCaseV1?.applicant}
      error={applicantDetailError || countryError}
      hasDataComponent={
        <CollapsibleApplicantProfile
          professional={applicantDetailData?.sendReportCaseV1?.applicant?.personalInformation?.professional as ApplicantUserProfessional}
          contactInformation={applicantDetailData?.sendReportCaseV1?.applicant?.personalInformation?.contactInformation as ApplicantUserContactInformation}
          identityDetails={applicantDetailData?.sendReportCaseV1?.applicant?.personalInformation?.identityDetails as ApplicantUserIdentityDetails}
          citizenship={applicantDetailData?.sendReportCaseV1?.applicant?.personalInformation?.citizenship as ApplicantUserCitizenship} 
          applyingTo={applicantDetailData?.sendReportCaseV1?.applicant?.personalInformation?.applyingTo as Entity[]}  
          countryData={
            countryData?.countries?.eventPayload?.countries as Country[]
          }
        />
      }
    />
  );
};
